export interface AdvantageItem {
    icon: string;
    textKey: string;
  }
  
  export interface AdvantageCard {
    titleKey: string;
    items: AdvantageItem[];
    cardClass?: string;
  }
  
  export const AdvantagesMock: AdvantageCard[] = [
    {
      titleKey: 'landing.comfortable',
      cardClass: 'advantages-card-green',
      items: [
        {
          icon: 'assets/icons/icon-location.svg',
          textKey: 'landing.comfortableDescription1',
        },
        {
          icon: 'assets/icons/icon-card.svg',
          textKey: 'landing.comfortableDescription2',
        },
        {
          icon: 'assets/icons/icon-doc_doc.svg',
          textKey: 'landing.comfortableDescription3',
        },
      ],
    },
    {
      titleKey: 'landing.legitimately',
      cardClass: 'advantages-card-blue',
      items: [
        {
          icon: 'assets/icons/icon-legitimatelyDesc1.svg',
          textKey: 'landing.legitimatelyDesc1',
        },
        {
          icon: 'assets/icons/icon-legitimatelyDesc2.svg',
          textKey: 'landing.legitimatelyDesc2',
        },
      ],
    },
    {
      titleKey: 'landing.reliable',
      cardClass: 'advantages-card-red',
      items: [
        {
          icon: 'assets/icons/icon-reliableDesc1.svg',
          textKey: 'landing.reliableDesc1',
        },
        {
          icon: 'assets/icons/icon-reliableDesc2.svg',
          textKey: 'landing.reliableDesc2',
        },
      ],
    },
  ];
  